import styles from './Table.module.scss';
import Tooltip from '../../components/Tooltip';

interface Props {
  tableHeader?: { title: string; tooltip?: string }[];
  children: any;
  getTableHeader?: () => void;
}
const Table = ({ tableHeader, children, getTableHeader }: Props): JSX.Element => {
  return (
    <table className={styles.tableContainer}>
      <thead>
        {tableHeader && (
          <tr>
            {tableHeader &&
              tableHeader.map(({ title, tooltip }, index) => (
                <th key={`${title}${index}`}>
                  {title}{' '}
                  {tooltip && (
                    <Tooltip
                      content={tooltip}
                      direction='top'
                      translateTooltip={{ transform: 'translate(17px, -12px)' }}
                      color='white'
                      maxWidth='80px'
                    >
                      <p className={styles.tooltipIcon}>?</p>
                    </Tooltip>
                  )}
                </th>
              ))}
          </tr>
        )}
        {getTableHeader && getTableHeader()}
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};

export default Table;
